import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["cpfInput"]

  checkExistenceCpf() {
    const cpf = this.cpfInputTarget.value
    if (cpf.length !== 14) {
      return;
    }
    $.ajax({
      url: "/patients/check_existence_cpf",
      method: "GET",
      data: {cpf},
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
    })
  }
}
